export default "__VITE_ASSET__p8UDM2iV__"